/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', () => {
  // Initialize the main slider
  const mainSlider = new Swiper('.main-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
  });

  // Initialize the thumbnail slider
  const thumbnailSlider = new Swiper('.thumbnail-slider', {
    slidesPerView: 3, // Default number of slides
    spaceBetween: 10,
    slideToClickedSlide: true, // Enable clicking on thumbnails
    breakpoints: {
      575: {
        slidesPerView: 4, // Show 3 slides on smaller screens
      },
    },
  });

  // Sync main slider with the thumbnail slider
  thumbnailSlider.on('click', (swiper) => {
    const clickedIndex = swiper.clickedIndex;
    mainSlider.slideTo(clickedIndex); // Move the main slider to the clicked index

    // Update the active class in the thumbnail slider
    updateThumbnailActiveClass(thumbnailSlider, clickedIndex);
  });

  mainSlider.on('slideChange', () => {
    const activeIndex = mainSlider.activeIndex;
    console.log("activeIndex",activeIndex);
    thumbnailSlider.slideTo(activeIndex); // Move the thumbnail slider to the active index

    // Update the active class in the thumbnail slider
    updateThumbnailActiveClass(thumbnailSlider, activeIndex);
    });
    
    // Function to update the active class in the thumbnail slider
    function updateThumbnailActiveClass(swiper, activeIndex) {
      swiper.slides.forEach((slide, index) => {
       
        if (index === activeIndex) {
          console.log("slide",slide);
          slide.classList.add('swiper-slide-active');
          slide.classList.add('active-thumb-slide');
        } else {
          slide.classList.remove('swiper-slide-active');
           slide.classList.remove('active-thumb-slide');
        }
      });
    }
    
    // Initialize the active class on page load
    updateThumbnailActiveClass(thumbnailSlider, mainSlider.activeIndex);

  // Full-screen slider initialization
  let fullscreenSlider = null;

  // Open full-screen modal
  document.querySelectorAll('.cst_zoom_icon_wrap').forEach((zoomBtn, index) => {
    zoomBtn.addEventListener('click', () => {
      const modal = document.querySelector('.fullscreen-modal');
      modal.style.display = 'block';
      modal.classList.add('modal-active');
      document.body.classList.add('overflow-hidden');
      // Initialize or update the fullscreen slider
      if (!fullscreenSlider) {
        fullscreenSlider = new Swiper('.fullscreen-slider', {
          slidesPerView: 1,
          initialSlide: index,
          navigation: {
            nextEl: '.fullscreen-next',
            prevEl: '.fullscreen-prev',
          },
        });
      } else {
        fullscreenSlider.slideTo(index); // Move to the correct slide
      }

      document.querySelector('.close-modal').addEventListener('click', () => {
          const modal = document.querySelector('.fullscreen-modal');
          modal.style.display = 'none';
          modal.classList.remove('modal-active');
          document.body.classList.remove('overflow-hidden');
      });

      var zoomPrevArrow = document.querySelector(".pswp__button.prevArrow");
      if(zoomPrevArrow){
        zoomPrevArrow.addEventListener('click',function(){
          document.querySelector(".swiper-button-prev.fullscreen-prev").click();
        });
      }
      var zoomNextArrow =  document.querySelector(".pswp__button.nextArrow");
      if(zoomNextArrow){
        zoomNextArrow.addEventListener('click',function(){
          document.querySelector(".swiper-button-next.fullscreen-next").click();
        })
      }
    });
  });

  

  var featured_collections = document.querySelectorAll(".custom-featured-collection .swiper");

  if (featured_collections.length) {
    featured_collections.forEach((featured_coll_slider) => {
      const autoplay_slider = featured_coll_slider.getAttribute("data-slider-autoplay");
  
      const swiperConfig = {
        slidesPerView: 1.1,
        navigation: {
          nextEl: featured_coll_slider.closest(".custom-featured-collection").querySelector(".swiper-button-next"),
          prevEl: featured_coll_slider.closest(".custom-featured-collection").querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          640: {
            slidesPerView: 2.5,
          },
          768: {
            slidesPerView: 3.5,
          },
          1024: {
            slidesPerView: 3.5,
          },
        },
      };
  
      if (autoplay_slider === "true") {
        swiperConfig.autoplay = {
          delay: 3000,
          disableOnInteraction: false,
        };
      }
  
      new Swiper(featured_coll_slider, swiperConfig);
    });
  }

  /* Recently viewed product custom slider */
  setTimeout(function(){
    var related_product_slider = document.querySelector('.cst__product-recently-viewed .recently-viewed-slider');
    if(related_product_slider != null){        
      const autoplay_slider = related_product_slider.getAttribute('data-slider-autoplay');      
      const swiperConfig = {
        slidesPerView: 1.1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 2.5,
          },
          768: {
            slidesPerView: 3.5,
          },
          1024: {
            slidesPerView: 3.5,
          },
        }
      };
    
      // Add autoplay to the Swiper config if autoplay_slider is true
      if (autoplay_slider === 'true') {
        swiperConfig.autoplay = {
          delay: 3000, // Adjust the delay as needed
          disableOnInteraction: false,
        };
      }  
      const featuredcollectionSlider = new Swiper('.recently-viewed-slider', swiperConfig);
    }
  },900); 
});

/////////////////////////// product tabs section //////////////////////////////////////

 document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-title');
  const contents = document.querySelectorAll('.tab-content');

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      tabs.forEach((item) => item.classList.remove('active'));
      contents.forEach((item) => item.classList.remove('active'));

      this.classList.add('active');
      document.querySelector(this.dataset.tabContent).classList.add('active');
    });
  });

  if (tabs.length > 0) {
    tabs[0].classList.add('active');
    contents[0].classList.add('active');
  }
});


// katalog page tab section scroll and active class in title on scroll and click
document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector(".header");
  var navBar = document.querySelector(".nav-bar");

  var headerHeight = header ? header.offsetHeight : 0;
  var navHeight = navBar ? navBar.offsetHeight : 0;

  // Calculate the total offset
  var totalOffset = headerHeight + navHeight + 30;
  console.log("totalOffset",totalOffset);
  
    var url = window.location.hash;
    // console.log("URL",url);
    if(url){

      const target = document.querySelector(url);
      if (target) {
          $('html, body').animate({
            scrollTop: target.offsetTop - totalOffset
          }, 500, 'linear');
      }
    }

  
  const navItems = document.querySelectorAll(".kataloge-vertical-navigation .navigation-linklist-item a");

  navItems.forEach(item => {
    item.addEventListener("click", function (e) {
      navItems.forEach(item => {
        item.closest(".navigation-linklist-item").classList.remove('active');
      });
      item.closest(".navigation-linklist-item").classList.add('active');
        e.preventDefault();
        const target = document.querySelector(this.getAttribute("href"));
         console.log("Target",target);

        if (target) {
          $('html, body').animate({
            scrollTop: target.offsetTop - totalOffset
          }, 500, 'linear');
        }
        window.location.hash = target.id; 
    });
  });

  const blockItems = document.querySelectorAll(".catalog-logo .block-wrapper a");
  blockItems.forEach(block => {
    block.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
         console.log("Target",target);

        if (target) {
          $('html, body').animate({
            scrollTop: target.offsetTop - totalOffset
          }, 500, 'linear');
        }
        window.location.hash = target.id; 
    });
  });

  function highlightActiveSection() {
    let scrollPosition = window.scrollY + totalOffset + 10;
    document.querySelectorAll(".catalog-information").forEach((section) => {
      let sectionTop = section.offsetTop;
      let sectionHeight = section.offsetHeight;

      if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
        let id = section.getAttribute("id");

        document.querySelectorAll(".navigation-linklist-item").forEach((li) => {
          li.classList.remove("active"); // Remove active class from all
        });

        let activeNavItem = document.querySelector(`.navigation-linklist-item a[href="#${id}"]`);
        if (activeNavItem) {
          activeNavItem.parentElement.classList.add("active"); // Add active class to parent <li>
        }
      }
    });
  }
  window.addEventListener("scroll", highlightActiveSection);
  highlightActiveSection();
});


// katalog page update progress bar on scroll page
  function updateProgressBar() {
    const progressBar = document.querySelector('.progress-bar');
    const totalHeight = document.body.scrollHeight - window.innerHeight;
    const progress = (window.pageYOffset / totalHeight) * 100;
    progressBar.style.width = progress + '%';
  }
  updateProgressBar(); 
  window.addEventListener('scroll', updateProgressBar);
  window.addEventListener('resize', updateProgressBar);

  function updateProgressCircle() {
    const progressElement = document.querySelector('.progress-circle-bar');
    if(progressElement){
       const scrollToTopElement = document.querySelector('.scroll-to-top');
    const totalHeight = document.body.scrollHeight - window.innerHeight;
    let progress = (window.pageYOffset / totalHeight) * 283;
    progress = Math.min(progress, 283);
    progressElement.style.strokeDashoffset = 283 - progress;
      if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight) {
        scrollToTopElement.style.opacity = '1';
      } else {
        scrollToTopElement.style.opacity = '0';
      }
    }
  }

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const scrollToTopElement = document.querySelector('.scroll-to-top');
  scrollToTopElement?.addEventListener('click', scrollToTop);
  updateProgressCircle();
  window.addEventListener('scroll', updateProgressCircle);
  window.addEventListener('resize', updateProgressCircle);


//////////////////// kATALOG PAGE MOBILE SIZE DROPDOWN  ////////////////////

var productCards = document.querySelectorAll(".vertical-navigation-main");
if (productCards.length) {
  productCards.forEach((productCard) => {
var quicksizeElem = productCard.querySelector(".vertical-navigation-main .vertical-navigation-mobile");
    if (quicksizeElem) {
      quicksizeElem.addEventListener('click', function () {
        productCards.forEach((card) => {
          if (card !== productCard) {
            let otherSizeElem = card.querySelector(".vertical-navigation-main .vertical-navigation-mobile");
            if (otherSizeElem) {
              otherSizeElem.classList.remove('active');
            }
          }
        });
        quicksizeElem.classList.toggle('active');
      });
    }
  });
}

